import type { UseQueryOptions } from '@tanstack/react-query';

import type { ClientApiV1CourseContractsInflearnMarketingContentsTermResponse } from '../../../src/@types/schema';
import {
  API_ENDPOINT,
  useClientApiV1CourseContractsInflearnMarketingContentsTermQuery,
} from '../../../src/@types/schema';

export default function useCourseContractsInflearnMarketingContentsTermQuery(
  options?: Omit<
    UseQueryOptions<ClientApiV1CourseContractsInflearnMarketingContentsTermResponse, unknown>,
    'queryKey' | 'queryFn' | 'initialData'
  >
) {
  return useClientApiV1CourseContractsInflearnMarketingContentsTermQuery({
    url: API_ENDPOINT.CLIENT_V1_COURSE_CONTRACTS_INFLEARN_MARKETING_CONTENTS_TERM,
    queryKey: [API_ENDPOINT.CLIENT_V1_COURSE_CONTRACTS_INFLEARN_MARKETING_CONTENTS_TERM],
    options: {
      ...options,
      staleTime: Infinity,
      suspense: false,
      useErrorBoundary: false,
    },
  });
}
